import React from 'react'
import ReactDOM from 'react-dom'
import $ from 'lib/jquery'
import RoomPageBase from './room-page-base'
import TuringTestSchedule from 'frontend/pages/rooms/turing-test-schedule'
import moment from 'lib/moment-timezone-custom'
import Glide, { Controls, Autoplay, Swipe, Images, Lazy, GLIDE_SETTINGS } from 'frontend/lib/glide/bundle'
import Reviews from 'frontend/pages/rooms/reviews'

export default class TuringTestPage extends RoomPageBase {
  static mountSchedule () {
    if (this.scheduleMounted || !this.scheduleRoot) return

    this.scheduleMounted = true

    ReactDOM.render(
      React.createElement(
        TuringTestSchedule,
        {
          roomId: parseInt(this.dataset.roomId),
          openedFrom: moment(this.dataset.openedFrom),
          prebookingCodeOnly: this.dataset.prebookingCodeOnly !== undefined
        }
      ),
      this.scheduleRoot
    )
  }

  static selectSlide (ev) {
    if (!ev.target.dataset.slide) { return }

    this.targetSlide = ev.target.dataset.slide
  }

  static handleRevealOpen () {
    if (this.revealSlider) {
      this.targetSlide && this.revealSlider.go(`=${this.targetSlide}`)
    } else {
      this.initRevealSlider()
    }
  }

  static initRevealSlider () {
    if (this.revealSlider) { return this.revealSlider }

    this.revealSlider = new Glide('.modal_images .slider',
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'carousel',
          focusAt: 'center',
          perView: 1,
          startAt: this.targetSlide || 0,
          lazyGlide: Object.assign(GLIDE_SETTINGS.lazyGlide, { processImages: true })
        }
      )
    ).mount({ Swipe, Controls, Images, Lazy })
  }

  static mobileSlider () {
    new Glide('.images .slider',
      Object.assign(
        GLIDE_SETTINGS,
        {
          type: 'carousel',
          focusAt: 'center',
          autoplay: 6000,
          perView: 1
        }
      )
    ).mount({ Swipe, Controls, Autoplay, Images })
  }

  static get dataset () {
    return document.body.dataset
  }

  static handleDOMReady () {
    super.handleDOMReady()
    $('#images_modal').on('open.zf.reveal', () => this.handleRevealOpen())
    document.querySelector('.mosaic').addEventListener('click', (ev) => this.selectSlide(ev))
  }

  static handleStylesApplied () {
    this.onEnter('.images .slider', () => this.mobileSlider())
    this.onEnter('.schedule_place', () => this.mountSchedule())
    setTimeout(() => this.mountSchedule(), this.scheduleFallbackDelay)
    Reviews.init()
  }
}

TuringTestPage.init()
